// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionAreaView-module__font-s-10___MY40t {
  font-size: 10px !important;
}

.ActionAreaView-module__font-s-12___bDwag {
  font-size: 12px !important;
}

.ActionAreaView-module__font-s-13___q1wE4 {
  font-size: 13px !important;
}

.ActionAreaView-module__font-s-14___xcy0E {
  font-size: 14px !important;
}

.ActionAreaView-module__font-s-15___khKqQ {
  font-size: 15px !important;
}

.ActionAreaView-module__font-s-16___CXtwk {
  font-size: 16px !important;
}

.ActionAreaView-module__font-s-18___mSFO_ {
  font-size: 18px !important;
}

.ActionAreaView-module__font-s-20___KcW8D {
  font-size: 20px !important;
}

.ActionAreaView-module__font-s-22___iwVVT {
  font-size: 22px !important;
}

.ActionAreaView-module__font-s-28___IR1n4 {
  font-size: 28px !important;
}

.ActionAreaView-module__font-w-400___EsWCA {
  font-weight: 400 !important;
}

.ActionAreaView-module__font-w-500___Aa7qq {
  font-weight: 500 !important;
}

.ActionAreaView-module__font-w-600___C0lBz {
  font-weight: 600 !important;
}

.ActionAreaView-module__font-w-700___SCHy0 {
  font-weight: 700 !important;
}

.ActionAreaView-module__p-5___CpB89 {
  padding: 5px !important;
}

.ActionAreaView-module__p-12___JzEcv {
  padding: 12px !important;
}

.ActionAreaView-module__p-16___Uwawm {
  padding: 16px !important;
}

.ActionAreaView-module__p-30___ZMD07 {
  padding: 30px !important;
}

.ActionAreaView-module__p-b-0___EUyCv {
  padding-bottom: 0 !important;
}

.ActionAreaView-module__p-b-5___oIcv3 {
  padding-bottom: 5px !important;
}

.ActionAreaView-module__p-b-10___vysC_ {
  padding-bottom: 10px !important;
}

.ActionAreaView-module__p-b-12___GM4FT {
  padding-bottom: 12px !important;
}

.ActionAreaView-module__p-b-16___WAnfj {
  padding-bottom: 16px !important;
}

.ActionAreaView-module__p-b-18___eXDF7 {
  padding-bottom: 18px !important;
}

.ActionAreaView-module__p-b-20___rgT4l {
  padding-bottom: 20px !important;
}

.ActionAreaView-module__p-b-25___SGflv {
  padding-bottom: 25px !important;
}

.ActionAreaView-module__p-b-30___p_Da_ {
  padding-bottom: 30px !important;
}

.ActionAreaView-module__p-b-50___egg2c {
  padding-bottom: 50px !important;
}

.ActionAreaView-module__p-t-0___p7qeM {
  padding-top: 0 !important;
}

.ActionAreaView-module__p-t-12___OVQXx {
  padding-top: 12px !important;
}

.ActionAreaView-module__p-t-16___MTmI8 {
  padding-top: 16px !important;
}

.ActionAreaView-module__p-t-18___VPlev {
  padding-top: 18px !important;
}

.ActionAreaView-module__p-t-20___A8CAO {
  padding-top: 20px !important;
}

.ActionAreaView-module__p-t-30___y05xd {
  padding-top: 30px !important;
}

.ActionAreaView-module__p-t-40___SgF9D {
  padding-top: 40px !important;
}

.ActionAreaView-module__p-t-50___dvnR4 {
  padding-top: 50px !important;
}

.ActionAreaView-module__p-l-20___F8cHC {
  padding-left: 20px !important;
}

.ActionAreaView-module__p-l-30___Iq0cu {
  padding-left: 30px !important;
}

.ActionAreaView-module__p-l-40___GTSk4 {
  padding-left: 40px !important;
}

.ActionAreaView-module__p-r-16___t6qoB {
  padding-right: 16px !important;
}

.ActionAreaView-module__p-r-20___K4irg {
  padding-right: 20px !important;
}

.ActionAreaView-module__p-r-30___N5q0r {
  padding-right: 30px !important;
}

.ActionAreaView-module__p-r-50___IX73Y {
  padding-right: 50px !important;
}

.ActionAreaView-module__p-r-60___iS3RF {
  padding-right: 60px !important;
}

.ActionAreaView-module__m-b-1___dhgqc {
  margin-bottom: 1px !important;
}

.ActionAreaView-module__m-b-2___Rp5S4 {
  margin-bottom: 2px !important;
}

.ActionAreaView-module__m-b-6___Htng3 {
  margin-bottom: 6px !important;
}

.ActionAreaView-module__m-b-8___m5CtA {
  margin-bottom: 8px !important;
}

.ActionAreaView-module__m-b-10___W7O2R {
  margin-bottom: 10px !important;
}

.ActionAreaView-module__m-b-14___FlAfc {
  margin-bottom: 14px !important;
}

.ActionAreaView-module__m-b-16___cf2w2 {
  margin-bottom: 16px !important;
}

.ActionAreaView-module__m-b-20___RXrjC {
  margin-bottom: 20px !important;
}

.ActionAreaView-module__m-b-22___ncM5Y {
  margin-bottom: 22px !important;
}

.ActionAreaView-module__m-b-24___izrnt {
  margin-bottom: 24px !important;
}

.ActionAreaView-module__m-b-30___vVAj7 {
  margin-bottom: 30px !important;
}

.ActionAreaView-module__m-b-32___A5hSK {
  margin-bottom: 32px !important;
}

.ActionAreaView-module__m-b-40___xYcA7 {
  margin-bottom: 40px !important;
}

.ActionAreaView-module__m-t-2___xIPYK {
  margin-top: 2px !important;
}

.ActionAreaView-module__m-t-3___QtQEv {
  margin-top: 3px !important;
}

.ActionAreaView-module__m-t-4___guv4p {
  margin-top: 4px !important;
}

.ActionAreaView-module__m-t-5___P3crQ {
  margin-top: 5px !important;
}

.ActionAreaView-module__m-t-8___WLKWI {
  margin-top: 8px !important;
}

.ActionAreaView-module__m-t-10___MZk8O {
  margin-top: 10px !important;
}

.ActionAreaView-module__m-t-15___xzAvE {
  margin-top: 15px !important;
}

.ActionAreaView-module__m-t-16___DYrWn {
  margin-top: 16px !important;
}

.ActionAreaView-module__m-t-20___E2tQJ {
  margin-top: 20px !important;
}

.ActionAreaView-module__m-t-22___n46es {
  margin-top: 22px !important;
}

.ActionAreaView-module__m-t-30___uRMFB {
  margin-top: 30px !important;
}

.ActionAreaView-module__m-t-32___o4p6y {
  margin-top: 32px !important;
}

.ActionAreaView-module__m-l-auto___YVpQH {
  margin-left: auto !important;
}

.ActionAreaView-module__m-l-4___JO0P2 {
  margin-left: 4px !important;
}

.ActionAreaView-module__m-l-5___7gMIu {
  margin-left: 5px !important;
}

.ActionAreaView-module__m-l-6___GyMkg {
  margin-left: 6px !important;
}

.ActionAreaView-module__m-l-8___Ytc_5 {
  margin-left: 8px !important;
}

.ActionAreaView-module__m-l-10___rYQ4p {
  margin-left: 10px !important;
}

.ActionAreaView-module__m-l-16___Q1SAP {
  margin-left: 16px !important;
}

.ActionAreaView-module__m-l-20___PfaWW {
  margin-left: 20px !important;
}

.ActionAreaView-module__m-l-24___yv6GR {
  margin-left: 24px !important;
}

.ActionAreaView-module__m-l-30___tHwBB {
  margin-left: 30px !important;
}

.ActionAreaView-module__m-l-35___OL_1X {
  margin-left: 35px !important;
}

.ActionAreaView-module__m-l-40___gdz9R {
  margin-left: 40px !important;
}

.ActionAreaView-module__m-r-8___EyJy5 {
  margin-right: 8px !important;
}

.ActionAreaView-module__m-r-10___i8n0y {
  margin-right: 10px !important;
}

.ActionAreaView-module__m-r-16___XB8YH {
  margin-right: 16px !important;
}

.ActionAreaView-module__m-r-20___V4PmY {
  margin-right: 20px !important;
}

.ActionAreaView-module__m-r-24___V0i46 {
  margin-right: 24px !important;
}

.ActionAreaView-module__m-r-30___XeIPq {
  margin-right: 30px !important;
}

.ActionAreaView-module__m-r-40____rDGi {
  margin-right: 40px !important;
}

.ActionAreaView-module__border-r-3___Q77T2 {
  border-radius: 3px !important;
}

.ActionAreaView-module__border-r-4___TRUjN {
  border-radius: 4px !important;
}

.ActionAreaView-module__border-r-6___sc0dI {
  border-radius: 6px !important;
}

.ActionAreaView-module__border-r-10___AzdQq {
  border-radius: 10px !important;
}

.ActionAreaView-module__border-r-12___xtATt {
  border-radius: 12px !important;
}

.ActionAreaView-module__border-r-16___XYKzs {
  border-radius: 16px !important;
}

.ActionAreaView-module__border-r-50___pzNnu {
  border-radius: 50% !important;
}

.ActionAreaView-module__primary-border___f3apI {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionAreaView-module__primary-border-b___LJa3b {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionAreaView-module__primary-border-t___fWSXC {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionAreaView-module__primary-border-l___tU7aV {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionAreaView-module__primary-border-r___mC7a7 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionAreaView-module__secondary-border___d7wCZ {
  border: 1px solid #637768;
}

.ActionAreaView-module__secondary-border-b___w1_Mn {
  border-bottom: 1px solid #637768;
}

.ActionAreaView-module__secondary-border-t___mJuZ5 {
  border-top: 1px solid #637768;
}

.ActionAreaView-module__secondary-border-l___uZH7F {
  border-left: 1px solid #637768;
}

.ActionAreaView-module__secondary-border-r___jdXWt {
  border-right: 1px solid #637768;
}

.ActionAreaView-module__gap-0___g3gkW {
  gap: 0 !important;
}

.ActionAreaView-module__gap-2___sUP4T {
  gap: 2px !important;
}

.ActionAreaView-module__gap-4___yEL0a {
  gap: 4px !important;
}

.ActionAreaView-module__gap-5___lXv5e {
  gap: 5px !important;
}

.ActionAreaView-module__gap-6___bokQt {
  gap: 6px !important;
}

.ActionAreaView-module__gap-8___kdk4t {
  gap: 8px !important;
}

.ActionAreaView-module__gap-10___u8tDE {
  gap: 10px !important;
}

.ActionAreaView-module__gap-12___cM47n {
  gap: 12px !important;
}

.ActionAreaView-module__gap-14___SLNjc {
  gap: 14px !important;
}

.ActionAreaView-module__gap-16___NoDPA {
  gap: 16px !important;
}

.ActionAreaView-module__gap-18___da_MJ {
  gap: 18px !important;
}

.ActionAreaView-module__gap-20___lBBdV {
  gap: 20px !important;
}

.ActionAreaView-module__gap-24___k9Maj {
  gap: 24px !important;
}

.ActionAreaView-module__gap-26___h_f06 {
  gap: 26px !important;
}

.ActionAreaView-module__gap-30___jRU_Q {
  gap: 30px !important;
}

.ActionAreaView-module__gap-32___nqmqi {
  gap: 32px !important;
}

.ActionAreaView-module__gap-40___oeyIB {
  gap: 40px !important;
}

.ActionAreaView-module__gap-50___dHE7R {
  gap: 50px !important;
}

.ActionAreaView-module__flex-1___W0k2q {
  flex: 1;
}

.ActionAreaView-module__flex-none___hiQzf {
  flex: none !important;
}

.ActionAreaView-module__flex-column___saVwK {
  display: flex;
  flex-direction: column !important;
}

.ActionAreaView-module__flex-row___wRfZ8 {
  display: flex;
  flex-direction: row !important;
}

.ActionAreaView-module__vertically-centered___gBAMZ {
  display: flex;
  align-items: center !important;
}

.ActionAreaView-module__horizontally-centered___yKUrP {
  display: flex;
  justify-content: center !important;
}

.ActionAreaView-module__horizontally-end___L99X1 {
  display: flex;
  justify-content: end !important;
}

.ActionAreaView-module__vertically-start___joEN2 {
  display: flex;
  align-items: start !important;
}

.ActionAreaView-module__space-between___bijjj {
  display: flex;
  justify-content: space-between !important;
}

.ActionAreaView-module__flex-wrap____7wcg {
  flex-wrap: wrap !important;
}

.ActionAreaView-module__height-100___bmIKQ {
  height: 100%;
}

.ActionAreaView-module__width-50___o85jz {
  width: 50% !important;
}

.ActionAreaView-module__width-100___puGwm {
  width: 100%;
}

.ActionAreaView-module__cursor-pointer___jKoZA {
  cursor: pointer;
}

.ActionAreaView-module__cursor-not-allowed___kGShb {
  cursor: not-allowed !important;
}

.ActionAreaView-module__absolute-centered___XYj5f {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ActionAreaView-module__absolute___pIHQK {
  position: absolute;
}

.ActionAreaView-module__relative___Py8Rt {
  position: relative;
}

.ActionAreaView-module__fixed____jLRq {
  position: fixed;
}

.ActionAreaView-module__visible___b99V1 {
  opacity: 1;
}

.ActionAreaView-module__invisible___Zw94p {
  opacity: 0;
}

.ActionAreaView-module__col-90___rV5OR {
  width: 90% !important;
}

.ActionAreaView-module__col-auto___KKn6o {
  width: auto !important;
}

.ActionAreaView-module__medical-tabs___qoMp8 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ActionAreaView-module__medical-table-new___Hue88 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ActionAreaView-module__medical-table-new___Hue88:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ActionAreaView-module__medical-table-new___Hue88::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ActionAreaView-module__medical-table-new___Hue88::-webkit-scrollbar-track {
  display: none;
}
.ActionAreaView-module__medical-table-new___Hue88.ActionAreaView-module__no-pagination___wct3E {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ActionAreaView-module__medical-table-new___Hue88.ActionAreaView-module__no-pagination___wct3E:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ActionAreaView-module__medical-table-new___Hue88.ActionAreaView-module__no-pagination___wct3E::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ActionAreaView-module__medical-table-new___Hue88.ActionAreaView-module__no-pagination___wct3E::-webkit-scrollbar-track {
  display: none;
}

.ActionAreaView-module__medical-table-empty___yveWz {
  padding: 14px 40px !important;
}

.ActionAreaView-module__icon-btn___eCSjJ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ActionAreaView-module__search-icon___SAlCV {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ActionAreaView-module__disable-select___e_vlK {
  user-select: none;
}

.ActionAreaView-module__break-word___XyUq6 {
  word-break: break-word;
}

.ActionAreaView-module__popup-clear-btn___IIEzk {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ActionAreaView-module__scroll-m-b-20___XoPK_ {
  scroll-margin-bottom: 20px;
}

.ActionAreaView-module__root___kCwj9 {
  display: block;
}

.ActionAreaView-module__pageHeader___NGat7 {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.ActionAreaView-module__pageTitle___sLuXU {
  font-size: 20px;
  font-weight: 600;
  color: #18181b;
  margin: 0 auto 0 0;
}

.ActionAreaView-module__segmentedControl___RmFMr {
  display: flex;
  gap: 2px;
  background: #f4f4f5;
  border-radius: 6px;
  padding: 2px;
}

.ActionAreaView-module__segmentButtonActive___l6Hxd {
  padding: 4px 12px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  background: #ffffff;
  color: #18181b;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  cursor: default;
}

.ActionAreaView-module__segmentButton___DJDig {
  padding: 4px 12px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: #71717a;
  cursor: pointer;
}
.ActionAreaView-module__segmentButton___DJDig:hover {
  color: #18181b;
}

.ActionAreaView-module__toolbar___aIZnQ {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  margin-bottom: 8px;
}

.ActionAreaView-module__periodRow___xj8aK {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 16px;
  row-gap: 10px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
}

.ActionAreaView-module__presetGroup___ggd4r {
  display: flex;
  gap: 4px;
  background: #f4f4f5;
  border-radius: 6px;
  padding: 2px;
}

.ActionAreaView-module__presetButton___JAFbo {
  padding: 3px 10px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 4px;
  border: 1px solid transparent;
  background: transparent;
  color: #71717a;
  cursor: pointer;
}

.ActionAreaView-module__presetButton___JAFbo:hover {
  color: #3f3f46;
}

.ActionAreaView-module__presetButtonActive___ER3oT {
  background: #ffffff;
  color: #18181b;
  border-color: #e4e4e7;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.ActionAreaView-module__dayChips___u0Spq {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.ActionAreaView-module__pickDateLabel___F1q97 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #71717a;
}

.ActionAreaView-module__dateInput___FaE8j {
  padding: 4px 8px;
  font-size: 13px;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #3f3f46;
}

.ActionAreaView-module__readout___BcLSV {
  margin-left: auto;
  white-space: nowrap;
  font-size: 13px;
  color: #71717a;
}

.ActionAreaView-module__handoffCard___G3bVf {
  margin-top: 12px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
}

.ActionAreaView-module__handoffBody___pbBAn {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 20px;
}

.ActionAreaView-module__handoffSummary___lYFGj {
  margin: 0;
  font-size: 15px;
  color: #3f3f46;
}

.ActionAreaView-module__handoffLink___SkVS1 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: #18181b;
  text-decoration: underline;
  text-decoration-color: #d4d4d8;
  text-underline-offset: 3px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}
.ActionAreaView-module__handoffLink___SkVS1:hover:not(:disabled) {
  border-color: #d4d4d8;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  text-decoration: none;
}
.ActionAreaView-module__handoffLink___SkVS1 {
  outline: none;
}
.ActionAreaView-module__handoffLink___SkVS1:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}
.ActionAreaView-module__handoffLink___SkVS1:disabled, .ActionAreaView-module__handoffLink___SkVS1[aria-disabled=true] {
  color: #a1a1aa;
  cursor: default;
}

.ActionAreaView-module__dayList___fnOwt {
  margin-top: 12px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  overflow: hidden;
}

.ActionAreaView-module__dayBody___YOUvf {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
}

.ActionAreaView-module__emptyState___PGM7v {
  margin: 0;
  font-size: 13px;
  color: #71717a;
}

.ActionAreaView-module__dayGroup___ADlHF {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ActionAreaView-module__dayRows___miaNA {
  display: flex;
  flex-direction: column;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/ActionAreaView/ActionAreaView.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AA8pBF;;AA3pBA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,yCAAA;EACA,eAAA;AA8pBF;;AA3pBA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AA8pBF;AA5pBE;EACE,cAAA;AA8pBJ;;AA1pBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AA6pBF;;AA1pBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AA6pBF;;AA1pBA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AA6pBF;;AA1pBA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AA6pBF;;AA1pBA;EACE,cAAA;AA6pBF;;AA1pBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,yCAAA;AA6pBF;;AA1pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA6pBF;;AA1pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AA6pBF;;AA1pBA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AA6pBF;;AA1pBA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AA6pBF;;AA1pBA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA6pBF;;AA1pBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AA6pBF;;AA1pBA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AA6pBF;;AA1pBA;EE/GE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,eAAA;EACA,sDAAA;AF6wBF;AE3wBE;EACE,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,qBAAA;AF6wBJ;AAprBA;EExHE,aAAA;AF+yBF;AE7yBE;EACE,0BAAA;EACA,mBALuB;AFozB3B;AE/wBE;EAEE,cAAA;EACA,eAAA;AFgxBJ;;AA3rBA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA8rBF;;AA3rBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AA8rBF;;AA3rBA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AA8rBF;;AA3rBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA8rBF;;AA3rBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA8rBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.root {\n  display: block;\n}\n\n.pageHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.pageTitle {\n  font-size: 20px;\n  font-weight: 600;\n  color: #18181b;\n  margin: 0 auto 0 0;\n}\n\n.segmentedControl {\n  display: flex;\n  gap: 2px;\n  background: #f4f4f5;\n  border-radius: 6px;\n  padding: 2px;\n}\n\n.segmentButtonActive {\n  padding: 4px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 4px;\n  border: none;\n  background: #ffffff;\n  color: #18181b;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  cursor: default;\n}\n\n.segmentButton {\n  padding: 4px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 4px;\n  border: none;\n  background: transparent;\n  color: #71717a;\n  cursor: pointer;\n\n  &:hover {\n    color: #18181b;\n  }\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 0;\n  margin-bottom: 8px;\n}\n\n.periodRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  column-gap: 16px;\n  row-gap: 10px;\n  padding: 16px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n}\n\n.presetGroup {\n  display: flex;\n  gap: 4px;\n  background: #f4f4f5;\n  border-radius: 6px;\n  padding: 2px;\n}\n\n.presetButton {\n  padding: 3px 10px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #71717a;\n  cursor: pointer;\n}\n\n.presetButton:hover {\n  color: #3f3f46;\n}\n\n.presetButtonActive {\n  background: #ffffff;\n  color: #18181b;\n  border-color: #e4e4e7;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.dayChips {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.pickDateLabel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.dateInput {\n  padding: 4px 8px;\n  font-size: 13px;\n  border-radius: 6px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #3f3f46;\n}\n\n.readout {\n  margin-left: auto;\n  white-space: nowrap;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.handoffCard {\n  margin-top: 12px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.handoffBody {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 20px;\n}\n\n.handoffSummary {\n  margin: 0;\n  font-size: 15px;\n  color: #3f3f46;\n}\n\n.handoffLink {\n  @include line-button;\n}\n\n.dayList {\n  margin-top: 12px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.dayBody {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 16px;\n}\n\n.emptyState {\n  margin: 0;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.dayGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.dayRows {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ActionAreaView-module__font-s-10___MY40t`,
	"fontS12": `ActionAreaView-module__font-s-12___bDwag`,
	"fontS13": `ActionAreaView-module__font-s-13___q1wE4`,
	"fontS14": `ActionAreaView-module__font-s-14___xcy0E`,
	"fontS15": `ActionAreaView-module__font-s-15___khKqQ`,
	"fontS16": `ActionAreaView-module__font-s-16___CXtwk`,
	"fontS18": `ActionAreaView-module__font-s-18___mSFO_`,
	"fontS20": `ActionAreaView-module__font-s-20___KcW8D`,
	"fontS22": `ActionAreaView-module__font-s-22___iwVVT`,
	"fontS28": `ActionAreaView-module__font-s-28___IR1n4`,
	"fontW400": `ActionAreaView-module__font-w-400___EsWCA`,
	"fontW500": `ActionAreaView-module__font-w-500___Aa7qq`,
	"fontW600": `ActionAreaView-module__font-w-600___C0lBz`,
	"fontW700": `ActionAreaView-module__font-w-700___SCHy0`,
	"p5": `ActionAreaView-module__p-5___CpB89`,
	"p12": `ActionAreaView-module__p-12___JzEcv`,
	"p16": `ActionAreaView-module__p-16___Uwawm`,
	"p30": `ActionAreaView-module__p-30___ZMD07`,
	"pB0": `ActionAreaView-module__p-b-0___EUyCv`,
	"pB5": `ActionAreaView-module__p-b-5___oIcv3`,
	"pB10": `ActionAreaView-module__p-b-10___vysC_`,
	"pB12": `ActionAreaView-module__p-b-12___GM4FT`,
	"pB16": `ActionAreaView-module__p-b-16___WAnfj`,
	"pB18": `ActionAreaView-module__p-b-18___eXDF7`,
	"pB20": `ActionAreaView-module__p-b-20___rgT4l`,
	"pB25": `ActionAreaView-module__p-b-25___SGflv`,
	"pB30": `ActionAreaView-module__p-b-30___p_Da_`,
	"pB50": `ActionAreaView-module__p-b-50___egg2c`,
	"pT0": `ActionAreaView-module__p-t-0___p7qeM`,
	"pT12": `ActionAreaView-module__p-t-12___OVQXx`,
	"pT16": `ActionAreaView-module__p-t-16___MTmI8`,
	"pT18": `ActionAreaView-module__p-t-18___VPlev`,
	"pT20": `ActionAreaView-module__p-t-20___A8CAO`,
	"pT30": `ActionAreaView-module__p-t-30___y05xd`,
	"pT40": `ActionAreaView-module__p-t-40___SgF9D`,
	"pT50": `ActionAreaView-module__p-t-50___dvnR4`,
	"pL20": `ActionAreaView-module__p-l-20___F8cHC`,
	"pL30": `ActionAreaView-module__p-l-30___Iq0cu`,
	"pL40": `ActionAreaView-module__p-l-40___GTSk4`,
	"pR16": `ActionAreaView-module__p-r-16___t6qoB`,
	"pR20": `ActionAreaView-module__p-r-20___K4irg`,
	"pR30": `ActionAreaView-module__p-r-30___N5q0r`,
	"pR50": `ActionAreaView-module__p-r-50___IX73Y`,
	"pR60": `ActionAreaView-module__p-r-60___iS3RF`,
	"mB1": `ActionAreaView-module__m-b-1___dhgqc`,
	"mB2": `ActionAreaView-module__m-b-2___Rp5S4`,
	"mB6": `ActionAreaView-module__m-b-6___Htng3`,
	"mB8": `ActionAreaView-module__m-b-8___m5CtA`,
	"mB10": `ActionAreaView-module__m-b-10___W7O2R`,
	"mB14": `ActionAreaView-module__m-b-14___FlAfc`,
	"mB16": `ActionAreaView-module__m-b-16___cf2w2`,
	"mB20": `ActionAreaView-module__m-b-20___RXrjC`,
	"mB22": `ActionAreaView-module__m-b-22___ncM5Y`,
	"mB24": `ActionAreaView-module__m-b-24___izrnt`,
	"mB30": `ActionAreaView-module__m-b-30___vVAj7`,
	"mB32": `ActionAreaView-module__m-b-32___A5hSK`,
	"mB40": `ActionAreaView-module__m-b-40___xYcA7`,
	"mT2": `ActionAreaView-module__m-t-2___xIPYK`,
	"mT3": `ActionAreaView-module__m-t-3___QtQEv`,
	"mT4": `ActionAreaView-module__m-t-4___guv4p`,
	"mT5": `ActionAreaView-module__m-t-5___P3crQ`,
	"mT8": `ActionAreaView-module__m-t-8___WLKWI`,
	"mT10": `ActionAreaView-module__m-t-10___MZk8O`,
	"mT15": `ActionAreaView-module__m-t-15___xzAvE`,
	"mT16": `ActionAreaView-module__m-t-16___DYrWn`,
	"mT20": `ActionAreaView-module__m-t-20___E2tQJ`,
	"mT22": `ActionAreaView-module__m-t-22___n46es`,
	"mT30": `ActionAreaView-module__m-t-30___uRMFB`,
	"mT32": `ActionAreaView-module__m-t-32___o4p6y`,
	"mLAuto": `ActionAreaView-module__m-l-auto___YVpQH`,
	"mL4": `ActionAreaView-module__m-l-4___JO0P2`,
	"mL5": `ActionAreaView-module__m-l-5___7gMIu`,
	"mL6": `ActionAreaView-module__m-l-6___GyMkg`,
	"mL8": `ActionAreaView-module__m-l-8___Ytc_5`,
	"mL10": `ActionAreaView-module__m-l-10___rYQ4p`,
	"mL16": `ActionAreaView-module__m-l-16___Q1SAP`,
	"mL20": `ActionAreaView-module__m-l-20___PfaWW`,
	"mL24": `ActionAreaView-module__m-l-24___yv6GR`,
	"mL30": `ActionAreaView-module__m-l-30___tHwBB`,
	"mL35": `ActionAreaView-module__m-l-35___OL_1X`,
	"mL40": `ActionAreaView-module__m-l-40___gdz9R`,
	"mR8": `ActionAreaView-module__m-r-8___EyJy5`,
	"mR10": `ActionAreaView-module__m-r-10___i8n0y`,
	"mR16": `ActionAreaView-module__m-r-16___XB8YH`,
	"mR20": `ActionAreaView-module__m-r-20___V4PmY`,
	"mR24": `ActionAreaView-module__m-r-24___V0i46`,
	"mR30": `ActionAreaView-module__m-r-30___XeIPq`,
	"mR40": `ActionAreaView-module__m-r-40____rDGi`,
	"borderR3": `ActionAreaView-module__border-r-3___Q77T2`,
	"borderR4": `ActionAreaView-module__border-r-4___TRUjN`,
	"borderR6": `ActionAreaView-module__border-r-6___sc0dI`,
	"borderR10": `ActionAreaView-module__border-r-10___AzdQq`,
	"borderR12": `ActionAreaView-module__border-r-12___xtATt`,
	"borderR16": `ActionAreaView-module__border-r-16___XYKzs`,
	"borderR50": `ActionAreaView-module__border-r-50___pzNnu`,
	"primaryBorder": `ActionAreaView-module__primary-border___f3apI`,
	"primaryBorderB": `ActionAreaView-module__primary-border-b___LJa3b`,
	"primaryBorderT": `ActionAreaView-module__primary-border-t___fWSXC`,
	"primaryBorderL": `ActionAreaView-module__primary-border-l___tU7aV`,
	"primaryBorderR": `ActionAreaView-module__primary-border-r___mC7a7`,
	"secondaryBorder": `ActionAreaView-module__secondary-border___d7wCZ`,
	"secondaryBorderB": `ActionAreaView-module__secondary-border-b___w1_Mn`,
	"secondaryBorderT": `ActionAreaView-module__secondary-border-t___mJuZ5`,
	"secondaryBorderL": `ActionAreaView-module__secondary-border-l___uZH7F`,
	"secondaryBorderR": `ActionAreaView-module__secondary-border-r___jdXWt`,
	"gap0": `ActionAreaView-module__gap-0___g3gkW`,
	"gap2": `ActionAreaView-module__gap-2___sUP4T`,
	"gap4": `ActionAreaView-module__gap-4___yEL0a`,
	"gap5": `ActionAreaView-module__gap-5___lXv5e`,
	"gap6": `ActionAreaView-module__gap-6___bokQt`,
	"gap8": `ActionAreaView-module__gap-8___kdk4t`,
	"gap10": `ActionAreaView-module__gap-10___u8tDE`,
	"gap12": `ActionAreaView-module__gap-12___cM47n`,
	"gap14": `ActionAreaView-module__gap-14___SLNjc`,
	"gap16": `ActionAreaView-module__gap-16___NoDPA`,
	"gap18": `ActionAreaView-module__gap-18___da_MJ`,
	"gap20": `ActionAreaView-module__gap-20___lBBdV`,
	"gap24": `ActionAreaView-module__gap-24___k9Maj`,
	"gap26": `ActionAreaView-module__gap-26___h_f06`,
	"gap30": `ActionAreaView-module__gap-30___jRU_Q`,
	"gap32": `ActionAreaView-module__gap-32___nqmqi`,
	"gap40": `ActionAreaView-module__gap-40___oeyIB`,
	"gap50": `ActionAreaView-module__gap-50___dHE7R`,
	"flex1": `ActionAreaView-module__flex-1___W0k2q`,
	"flexNone": `ActionAreaView-module__flex-none___hiQzf`,
	"flexColumn": `ActionAreaView-module__flex-column___saVwK`,
	"flexRow": `ActionAreaView-module__flex-row___wRfZ8`,
	"verticallyCentered": `ActionAreaView-module__vertically-centered___gBAMZ`,
	"horizontallyCentered": `ActionAreaView-module__horizontally-centered___yKUrP`,
	"horizontallyEnd": `ActionAreaView-module__horizontally-end___L99X1`,
	"verticallyStart": `ActionAreaView-module__vertically-start___joEN2`,
	"spaceBetween": `ActionAreaView-module__space-between___bijjj`,
	"flexWrap": `ActionAreaView-module__flex-wrap____7wcg`,
	"height100": `ActionAreaView-module__height-100___bmIKQ`,
	"width50": `ActionAreaView-module__width-50___o85jz`,
	"width100": `ActionAreaView-module__width-100___puGwm`,
	"cursorPointer": `ActionAreaView-module__cursor-pointer___jKoZA`,
	"cursorNotAllowed": `ActionAreaView-module__cursor-not-allowed___kGShb`,
	"absoluteCentered": `ActionAreaView-module__absolute-centered___XYj5f`,
	"absolute": `ActionAreaView-module__absolute___pIHQK`,
	"relative": `ActionAreaView-module__relative___Py8Rt`,
	"fixed": `ActionAreaView-module__fixed____jLRq`,
	"visible": `ActionAreaView-module__visible___b99V1`,
	"invisible": `ActionAreaView-module__invisible___Zw94p`,
	"col90": `ActionAreaView-module__col-90___rV5OR`,
	"colAuto": `ActionAreaView-module__col-auto___KKn6o`,
	"medicalTabs": `ActionAreaView-module__medical-tabs___qoMp8`,
	"medicalTableNew": `ActionAreaView-module__medical-table-new___Hue88`,
	"noPagination": `ActionAreaView-module__no-pagination___wct3E`,
	"medicalTableEmpty": `ActionAreaView-module__medical-table-empty___yveWz`,
	"iconBtn": `ActionAreaView-module__icon-btn___eCSjJ`,
	"searchIcon": `ActionAreaView-module__search-icon___SAlCV`,
	"disableSelect": `ActionAreaView-module__disable-select___e_vlK`,
	"breakWord": `ActionAreaView-module__break-word___XyUq6`,
	"popupClearBtn": `ActionAreaView-module__popup-clear-btn___IIEzk`,
	"scrollMB20": `ActionAreaView-module__scroll-m-b-20___XoPK_`,
	"root": `ActionAreaView-module__root___kCwj9`,
	"pageHeader": `ActionAreaView-module__pageHeader___NGat7`,
	"pageTitle": `ActionAreaView-module__pageTitle___sLuXU`,
	"segmentedControl": `ActionAreaView-module__segmentedControl___RmFMr`,
	"segmentButtonActive": `ActionAreaView-module__segmentButtonActive___l6Hxd`,
	"segmentButton": `ActionAreaView-module__segmentButton___DJDig`,
	"toolbar": `ActionAreaView-module__toolbar___aIZnQ`,
	"periodRow": `ActionAreaView-module__periodRow___xj8aK`,
	"presetGroup": `ActionAreaView-module__presetGroup___ggd4r`,
	"presetButton": `ActionAreaView-module__presetButton___JAFbo`,
	"presetButtonActive": `ActionAreaView-module__presetButtonActive___ER3oT`,
	"dayChips": `ActionAreaView-module__dayChips___u0Spq`,
	"pickDateLabel": `ActionAreaView-module__pickDateLabel___F1q97`,
	"dateInput": `ActionAreaView-module__dateInput___FaE8j`,
	"readout": `ActionAreaView-module__readout___BcLSV`,
	"handoffCard": `ActionAreaView-module__handoffCard___G3bVf`,
	"handoffBody": `ActionAreaView-module__handoffBody___pbBAn`,
	"handoffSummary": `ActionAreaView-module__handoffSummary___lYFGj`,
	"handoffLink": `ActionAreaView-module__handoffLink___SkVS1`,
	"dayList": `ActionAreaView-module__dayList___fnOwt`,
	"dayBody": `ActionAreaView-module__dayBody___YOUvf`,
	"emptyState": `ActionAreaView-module__emptyState___PGM7v`,
	"dayGroup": `ActionAreaView-module__dayGroup___ADlHF`,
	"dayRows": `ActionAreaView-module__dayRows___miaNA`
};
module.exports = ___CSS_LOADER_EXPORT___;
